import { useEffect, useState } from 'react';

const EMPTY = {
  idPersona: 0,
  tipoDireccion: '',
  calle: '',
  numeroExterior: '',
  numeroInterior: '',
  colonia: '',
  municipio: '',
  estado: '',
  codigoPostal: '',
  pais: '',
  esPrincipal: false,
};

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);

  useEffect(() => {
    if (mode === 'edit' && data) {
      setForm({
        idDireccion: data.idDireccion ?? 0,
        idPersona: data.idPersona ?? 0,
        tipoDireccion: data.tipoDireccion ?? '',
        calle: data.calle ?? '',
        numeroExterior: data.numeroExterior ?? '',
        numeroInterior: data.numeroInterior ?? '',
        colonia: data.colonia ?? '',
        municipio: data.municipio ?? '',
        estado: data.estado ?? '',
        codigoPostal: data.codigoPostal ?? '',
        pais: data.pais ?? '',
        esPrincipal: !!data.esPrincipal,
      });
    } else {
      setForm(EMPTY);
    }
  }, [mode, data]);

  if (!open) return null;

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nueva dirección' : 'Editar dirección'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>ID Persona:</label>
        <br /><br />
        <input
          className="infoField"
          type="number"
          min={1}
          value={form.idPersona}
          onChange={(e) => setForm({ ...form, idPersona: Number(e.target.value) || 0 })}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo de dirección:</label>
        <br /><br />
        <select
          className="infoField"
          value={form.tipoDireccion}
          onChange={(e) => setForm({ ...form, tipoDireccion: e.target.value })}
        >
          <option value="">Seleccione…</option>
          <option value="Casa">Casa</option>
          <option value="Trabajo">Trabajo</option>
          <option value="Otro">Otro</option>
        </select>
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Calle:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.calle}
          onChange={(e) => setForm({ ...form, calle: e.target.value })}
          maxLength={150}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Número exterior:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.numeroExterior}
          onChange={(e) => setForm({ ...form, numeroExterior: e.target.value })}
          maxLength={20}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Número interior:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.numeroInterior}
          onChange={(e) => setForm({ ...form, numeroInterior: e.target.value })}
          maxLength={20}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Colonia:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.colonia}
          onChange={(e) => setForm({ ...form, colonia: e.target.value })}
          maxLength={150}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Municipio:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.municipio}
          onChange={(e) => setForm({ ...form, municipio: e.target.value })}
          maxLength={150}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Estado:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.estado}
          onChange={(e) => setForm({ ...form, estado: e.target.value })}
          maxLength={150}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Código postal:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.codigoPostal}
          onChange={(e) => setForm({ ...form, codigoPostal: e.target.value })}
          maxLength={10}
        />
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>País:</label>
        <br /><br />
        <input
          className="infoField"
          value={form.pais}
          onChange={(e) => setForm({ ...form, pais: e.target.value })}
          maxLength={120}
        />
      </div>

      <div style={{ gridColumn: '1 / 3' }}>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>
          <input
            type="checkbox"
            checked={form.esPrincipal}
            onChange={(e) => setForm({ ...form, esPrincipal: e.target.checked })}
            style={{ marginRight: '.5rem' }}
          />
          Principal
        </label>
      </div>
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="roles-btn" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => onSubmit(form, mode)}
        disabled={
          !form.idPersona ||
          !form.tipoDireccion ||
          !form.calle?.trim() ||
          !form.numeroExterior?.trim() ||
          !form.numeroInterior?.trim() ||
          !form.colonia?.trim() ||
          !form.municipio?.trim() ||
          !form.estado?.trim() ||
          !form.codigoPostal?.trim() ||
          !form.pais?.trim()
        }
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
